import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// Mock for now user type - TODO implement user type
const isExternalUser = true;

export const externalUserGuard: CanActivateFn = () => {
  const router = inject(Router);

  if (isExternalUser) {
    return true;
  } else {
    router.navigate(['/404']);
    return false;
  }
};
